import React from "react"
import { CalendarDatePickerSeeker, disabledBefore } from '@ui-seeker/core'

import { rentalDates } from "@signals"


export default function AppCommonFiltersRentalDatesMultiPicker({ ...props }) {


	return <CalendarDatePickerSeeker
		shouldDisableDate={disabledBefore(new Date(Date.now() - 28 * 24 * 60 * 60 * 1000))}
		value={rentalDates.value}
		onChange={e => rentalDates.value = e}
		placeholder="Select rental dates"
		label="Rental dates"
		{...props}
	/>
}